import { FormsService } from "../../../services/forms/forms.service";
import { AuthSquareUserRequestActionType } from "../types";

export function* authSquareUserSaga({ payload }: AuthSquareUserRequestActionType) {
    try {
        const {
            data: { data },
        } = yield FormsService.getPaymentSquareAuthURL();
        window.open(data, "_self");
    } catch (error) {
        console.log("Stripe Auth Error", error);
        // yield put(Handle Error);
    }
}
